import { Action, Types } from "./personalPlanningChannel.actions"

export type PersonalPlanningChannelPayload = {
  uid: string
  week: string
  from: string
  to: string
}

export type PersonalPlanningChannelState = {
  connected: boolean
  errors: object
  connecting: boolean
}

const initialState: PersonalPlanningChannelState = {
  connected: false,
  errors: {},
  connecting: false,
}

export default (state = initialState, action: Action): PersonalPlanningChannelState => {
  switch (action.type) {
    case Types.CONNECT:
      return {
        ...state,
        connecting: true,
      }

    case Types.CONNECTION_SUCCESS:
      return {
        ...state,
        connected: true,
        connecting: false,
      }

    case Types.CONNECTION_FAILED:
      return {
        ...state,
        errors: action.payload.errors,
        connecting: false,
        connected: false,
      }

    case Types.DISCONNECT:
      return {
        ...state,
        connecting: false,
      }

    case Types.DISCONNECT_SUCCESS:
      return {
        ...state,
        connected: false,
        connecting: false,
      }

    case Types.DISCONNECT_FAILED:
      return {
        ...state,
        errors: action.payload.errors,
        connecting: false,
        connected: false,
      }

    default:
      return state
  }
}
